import React, { useEffect, useState } from 'react';
import './gyogik.css';
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

function Gyogik() {
  

  const [data, setData] = useState([]);
  const [gyogik, setgyogik] = useState([]);
  const [gikwon, setgikwon] = useState([]);
  const [ form, setForm ] = useState({ id: '' });

  /* 26.04.28 미사용 데이터 주석처리
  useEffect(() => {
    const url3 = "/backend/gyogik";
    fetch(url3)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setgyogik(data);
        //console.log(Array.isArray(data) + ": " + " gyogik data now changed");
      });
  }, []);
  */

  const [isVisible, setIsVisible] = useState(false); // 초기 상태는 '숨김'으로 설정합니다.
  const menuItems = {
	'교학처':[
	 { name: '강릉교학처', code: '41000'},
	 { name: '강릉교육지원과', code: '41001'},
	 { name: '강릉학생지원과', code: '41002'},
	 { name: '원주교학처', code: '3W410'},
	 { name: '원주교육학생지원과', code: '3W411'},
	],
	'기획연구처':[
	 { name: '강릉기획연구처', code: '42000'},
	 { name: '강릉기획지원과', code: '42001'},
	 { name: '강릉연구지원과', code: '42002'},
	 { name: '원주기획연구처', code: '3W420'},
	 { name: '원주기획연구지원과', code: '3W421'},
	],
	'행정본부':[
	 { name: '강릉행정본부', code: '43000'},
	 { name: '강릉행정지원과', code: '43010'},
	 { name: '강릉시설지원과', code: '43020'},
	 { name: '원주행정본부', code: '3W430'},
	 { name: '원주행정시설지원과', code: '3W431'},
	],
	'입학본부':[
	 { name: '강릉입학본부', code: '44000'},
	 { name: '원주입학본부', code: '3W440'},
	],
	'산학협력단':[
	 { name: '강릉산학협력단', code: '52000'},
	 { name: '산학협력종합지원본부', code: '52001'},
	 { name: '강릉산학경영지원부', code: '52002'},
	 { name: '강릉산학연구지원부', code: '52003'},
	 { name: '창업지원본부', code: '52004'},
	 { name: '동해안해양생물자원연구센터', code: '52005'},
	 { name: '파인세라믹지역기술혁신센터', code: '52006'},
	 { name: '강원ICT융합연구원', code: '52007'},
	 { name: 'GIS교육연구센터', code: '52008'},
	 { name: '웰빙농산업정보원', code: '52009'},
	 { name: '신소재융복합기술연구소', code: '52010'},
	 { name: '강릉시어린이사회복지급식관리지원센터', code: '52011'},
	 { name: '강원씨그랜트센터', code: '52012'},
	 { name: '음악교육지원센터', code: '52013'},
	 { name: '해람과학교육센터', code: '52014'},
	 { name: '강원어촌특화지원센터', code: '52015'},
	 { name: '강원귀어학교', code: '52016'},
	 { name: '동해안수산물안전관리센터', code: '52017'},
	 { name: '첨단산업인재양성부트캠프사업단', code: '52018'},
	 { name: '에코바이오연구센터', code: '52019'},
	 { name: '에너지바이오화학융합연구소', code: '52020'},
	 { name: '글로컬학연플랫폼센터', code: '52021'},
	 { name: '자연기술센터', code: '52022'},
	 { name: '학교기업솔테', code: '52023'},
	 { name: '원주산학협력단', code: '3W450'},
	 { name: '원주산학협력지원부', code: '3W451'},
	 { name: '강원도박문제예방치유센터', code: '3W452'},
	 { name: '해양센서네트워크시스템기술연구센터', code: '3W453'},
	 { name: '산학융합지구사업단', code: '3W454'},
	 { name: 'SW미래채움원주거점센터', code: '3W455'},
	],
	'교육기본시설': [
		{ name: '강릉캠퍼스도서관' , code: '3C001'},
		{ name: '원주캠퍼스도서관' , code: '3W601'},
	],
	'부속시설': [
		{ name: '박물관' , code : '4B009' },
		{ name: '강릉공동실험실습관' , code : '4B138' },
		{ name: '강릉평생교육원' , code : '4B144' },
		{ name: '원주평생교육원' , code : '3W704' },
		{ name: '농수산인교육원' , code : '4B027' },
		{ name: '강릉체육진흥원' , code : '4B143' },
		{ name: '산학연협력선도대학육성사업단' , code : '4B126' },
		{ name: '해양과학교육원' , code : '4B114' },
		
	],
	'단과대행정실': [
		{ name: '제7행정실' , code : '1H700' },
		{ name: '제11행정실' , code : '1H110' },
    ],
	'인문대학(강릉)':[
		{ name: '인문대학(강릉)' , code : '1B000' }, 
		{ name: '국어국문학과' , code : '1B001' }, 
		{ name: '영어영문학과' , code : '1B002' },  
		{ name: '중어중문학과' , code : '1B003' },
		{ name: '일본학과' , code : '1B004' }, 
		{ name: '철학과' , code : '1B005' }, 
		{ name: '사학과' , code : '1B006' },
		{ name: '인문대학자유전공학과' , code : '1B007' },
		{ name: '자유전공학부' , code : '1B008' },		
		{ name: '글로벌융합학부' , code : '1B009' },
		{ name: '교직과정부' , code : '1B010' },
		{ name: '독어독문학과' , code : '1B011' },
	],
	'사회과학대학(강릉)':[
		{ name: '사회과학대학(강릉)' , code : '1F000' }, 
		{ name: '경영학과' , code : '1F001' }, 
		{ name: '회계학과' , code : '1F002' }, 
		{ name: '관광경영학과' , code : '1F003' },
		{ name: '경제학과' , code : '1F004' }, 
		{ name: '무역학과' , code : '1F005' }, 
		{ name: '국제통상학과' , code : '1F006' },
		{ name: '도시계획·부동산학과' , code : '1F007' }, 
		{ name: '정책학과' , code : '1F008' }, 
		{ name: '자치행정학과' , code : '1F009' }, 
	],
	'자연과학대학(강릉)':[
		{ name: '자연과학대학(강릉)' , code : '1J000' }, 
		{ name: '수학물리학부' , code : '1J001' },
		{ name: '데이터사이언스학과' , code : '1J004' },
		{ name: '대기환경과학과' , code : '1J005' },
		{ name: '화학신소재학과' , code : '1J006' },		
		{ name: '자연과학대학자유전공학과' , code : '1J007' },
	],
	'자연과학대학(춘천)':[
		{ name: '자연과학대학(춘천)' , code : '1K000' },
		{ name: '생명과학과' , code : '1K001' },
	],
	'생명과학대학': [
		{ name: '생명과학대학' , code : '1M000' }, 
		{ name: '식물생명과학과' , code : '1M017' },
		{ name: '식품영양학과' , code : '1M018' },
		{ name: '수산생명의학과' , code : '1M025' },
		{ name: '해양융합과학과' , code : '1M030' },
		{ name: '환경조경학과' , code : '1M010'},
		{ name: '생명과학대학자유전공학과' , code : '1M031'},
		{ name: '생명과학대학부속농장' , code : '1M032' }, 
    ],
    '공과대학': [
		{ name: '공과대학' , code : '1P000' }, 
		{ name: '신소재·생명화학공학부' , code : '1P037' }, 
		{ name: '전자·반도체공학부' , code : '1P034' }, 
		{ name: '건설환경공학부' , code : '1P044' }, 
    ],
    '예술체육대학': [
		{ name: '예술체육대학' , code : '1S000' }, 
		{ name: '조형예술·디자인학과' , code : '1S009' }, 
		{ name: '체육학과' , code : '1S004' }, 
		{ name: '음악학과' , code : '1S010' }, 
		{ name: '패션디자인학과' , code : '1S007' }, 
    ],
    '치과대학': [
		{ name: '치과대학' , code : '1V000' },
		{ name: '치의예과' , code : '1V003' }, 		
		{ name: '치의학과' , code : '1V001' }, 
		{ name: '치위생학과' , code : '1V002' }, 
    ],
    '보건복지대학': [
		{ name: '보건복지대학' , code : '1X800' }, 
		{ name: '간호학과' , code : '1X804' }, 
		{ name: '유아교육과' , code : '1X803' }, 
		{ name: '다문화학과' , code : '1X802' }, 
		{ name: '사회복지학과' , code : '1X805' }, 
		{ name: '디지털미디어커뮤니케이션학부' , code : '1X806' }, 
    ],
    '과학기술대학': [
		{ name: '과학기술대학' , code : '1X600' }, 
		{ name: 'AI콘텐츠공학과' , code : '1X617' }, 
		{ name: '전기공학과' , code : '1X608' }, 
		{ name: '정보통신공학과' , code : '1X609' }, 		
		{ name: '산업경영공학과' , code : '1X611' }, 
    ],
	'IT대학': [
		{ name: 'IT대학' , code : '1XA00' }, 
		{ name: '컴퓨터공학과' , code : '1XA01' }, 
	],
	'문화예술·공과대학': [
		{ name: '문화예술·공과대학' , code : '1XB00' }, 
		{ name: '기계융합공학부' , code : '1XB01' }, 
	],

  };

  const [visibleMenu, setVisibleMenu] = useState(
    Object.keys(menuItems).reduce((acc, menuName) => {
      acc[menuName] = false;
      return acc;
    }, {})
  );

  const toggleMenu = (menuName) => {
    setVisibleMenu((prevVisibleMenu) => ({
      ...prevVisibleMenu,
      [menuName]: !prevVisibleMenu[menuName],
    }));
  };
{/* 메뉴 탭 */}


  useEffect(() => {
    const url4 = "/backend/gikwon";
    fetch(url4)
      .then((response) => response.json())
      .then((data1) => {
       // console.log(data1);
        setgikwon(data1);
       // console.log(Array.isArray(data1));
      });
  }, []);
  const [searchTerm, setSearchTerm] = useState(""); // 검색어 상태

  const handleSearch = (e) => {
    setSearchTerm(e.target.value); // 검색어 업데이트
    //console.log(e.target.name + ": " + "now changed");
    //console.log(e.target.value + ": " + "now changed");

		const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value;
		}
  };

/////////////////////////////////////
/////////////////////////////////////


	const { id } = form;
	const navigate = useNavigate();
	const clicked = (e) => {

		//if(id === '') alert('검색어를 입력해주세요.');
		var strtarget  = e.target.id;
		console.log("Clicked item strtarget ID:", strtarget); // 클릭한 개체의 아이디 값 로그로 찍기
		var str  = "";
		var bstr = "0";
		
		if (strtarget === "AAA" || strtarget === "" ) {
			str  = document.getElementById("name-input").value;
			bstr = "0";
		} else {
			str  = strtarget;
			bstr = "1";

	    }

		console.log(e.target.name + ": " + "now changed");
		console.log(e.target.value + ": " + "now changed");
		console.log(str + ": " + " str now changed");
		console.log("now clicked");
		navigate("/Gyogik_search/", { state: { id: str, bid: bstr } });
	};

/////////////////////////////////////
//핸드폰 엔터키 검색 버튼 클릭
/////////////////////////////////////
  const handleKeyPress = (event) => {

    // 눌린 키의 keyCode 값이 13이면 엔터 키를 의미함
    const inputValue = event.target.value; // 입력된 텍스트 값

    if (event.key === 'Enter') {

      // 여기에 엔터 키가 눌렸을 때 실행할 동작을 추가할 수 있습니다.
		var strtarget  = event.target.id;
		var str  = "";
		var bstr = "0";
		
		if (strtarget === "AAA" || strtarget === "" || strtarget === "name-input" ) {
			str  = event.target.value;
			bstr = "0";
		} else {
			str  = strtarget;
			bstr = "1";
	    }
		navigate("/Gyogik_search/", { state: { id: str, bid: bstr } });
    }
    //alert('['+event.key + ']====111키가 눌렸습니다!2');
    // 엔터 키가 입력되었을 때

  };

/////////////////////////////////////
/////////////////////////////////////

  // 검색어와 일치하는 항목을 필터링하는 함수
  const filterMenuItems = (searchTerm) => {
    if (searchTerm === "") { // 검색어가 없는 경우 전체 항목 반환
      return menuItems;
    }

    // 검색어가 있는 경우 일치하는 항목만 필터링하여 반환
    const filteredItems = {};
    for (const menuName in menuItems) {
      const filteredSubItems = menuItems[menuName].filter((item) =>
        item.name.includes(searchTerm)
      );
      if (filteredSubItems.length > 0) {
        filteredItems[menuName] = filteredSubItems;
      }
    }
    return filteredItems;
  };

  // 검색어에 따라 필터링된 항목을 가져옵니다.
  const filteredMenuItems = filterMenuItems(searchTerm);
  
  return (

  <div className="container">
      <div className="page" style={{margin:"0 10px"}}>
        <div className="AppG App-headerG gnb_bsG">
        <header style={{width: "100%"}}>
          <div className="gnb_1">
          <button onClick={() => window.history.back()} class="arrow-button">
              <span class="arrow-icon"></span>
            </button>
                <span className="title">교직원 수첩</span>
                <div className="gnb_1_1">
                    {/*<Link className="gnb_qrG" to="/qr">
                        <div className="gnb_qrG"></div>
                    </Link>*/}
                 {/*  <a className="gnb_notiG" href="/"></a> */}
                </div>
          </div>
        </header>
          <div className="body">
          <div className="search-container">
            <div className="input_box">
           <button id="AAA" onClick={clicked} >검색</button> {/* <button onClick={handleSearchClick}>검색</button> 검색 버튼을 누르면 handleSearchClick 함수를 호출하여 gyogik_search.js로 이동 */}
              <input
                type="text"
                name="id"  id="name-input"
                value={searchTerm}
                onChange={handleSearch}
				onKeyPress={handleKeyPress}
                placeholder="이름, 업무, 전화번호를 검색해보세요."
                className="search-input"
				required
              />
			<div className="search-icon"> </div>

            </div>
            </div>
            {Object.keys(filteredMenuItems).map((menuName) => (
              <div key={menuName}>
                <div className="buseo" onClick={() => toggleMenu(menuName)}>
                  <span>{menuName}</span>
                </div>
                {visibleMenu[menuName] &&
                  filteredMenuItems[menuName].map((menuItem) => (
   
                      <div className="detail" id={menuItem.code} onClick={clicked} key={menuItem.code} >
                      {menuItem.name}
                      </div>


                      ))}
					  
                      </div>
                      ))}
                      </div>
                      </div>
                      </div>
                      </div>
                      );
                      }
                      
                      export default Gyogik;
					  {/* Gyogik_info  Gyogik_search to={`/Gyogik_search/${menuItem.code}/${menuItem.name}`} */}